<template>
	<!--<router-view></router-view>-->
	<Panier v-if="template == 't-cart.php'"/>
	<Caisse v-if="template == 't-checkout-stereo.php'"/>
	<Success v-if="template == 't-success.php'"/>
	<Connexion v-if="template == 't-login.php'"/>
	<Dashboard v-if="template == 't-dashboard.php'"/>
	<Invoice v-if="template == 't-invoice.php'"/>
</template>

<script>
import Panier from './components/ProductCart.vue'
import Caisse from './components/CartCheckout.vue'
import Success from './components/CheckoutSuccess.vue'
import Connexion from './components/CustomerLogin.vue'
import Dashboard from './components/CustomerDashboard.vue'
import Invoice from './components/CustomerInvoice.vue'
import TranslationStrings from './translationStrings.js'

export default {
	name: 'App',
	data() {
		return {
			path: window.location.pathname,
			template: window.ajax_var.currentPage,
			language: window.ajax_var.currentLang,
			translationStrings: TranslationStrings(),
			// translations: {
			// 	'Commander': {
			// 		fr: 'Commander',
			// 		en: 'Checkout'
			// 	},
			// }
		}
	},
	//Dom watcher on body class
	mounted() {
		//this.$root.$on('changeLanguage', this.changeLanguage)
		if (this.$el.parentNode.dataset.language) {
			this.language = this.$el.parentNode.dataset.language;
		}
		if(this.$el.parentNode.dataset.template) {
			this.template = 't-'+this.$el.parentNode.dataset.template+'.php';
		}
		//this.initMutationObserver();

		if (typeof window.showTranslations === 'undefined') {
			window.showTranslations = this.showTranslations
		}
	},
	methods: {
		translateString(text) {
			let translationStrings = this.$root.translationStrings
			let lang = this.$root.language

			if (!translationStrings[text]) translationStrings[text] = {}
			if (!translationStrings[text]['fr']) translationStrings[text]['fr'] = text
			if (!translationStrings[text]['en']) translationStrings[text]['en'] = text
			if (!translationStrings[text][lang]) translationStrings[text][lang] = text //if other languages

			return translationStrings[text][lang]
		},

		showTranslations() {
			return this.$root.translationStrings
		}
	},
	components: {
		Connexion,
		Panier,
		Caisse,
		Success,
		Dashboard,
		Invoice
	},
}
</script>
